import script from "./SliderCart.vue?vue&type=script&setup=true&lang=js"
export * from "./SliderCart.vue?vue&type=script&setup=true&lang=js"

import "./SliderCart.vue?vue&type=style&index=0&id=750ec198&lang=css"

const __exports__ = script;

export default __exports__